export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'left',
    width: 80,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'seqNo',
    title: '批次号',
    align: 'center',
    fixed: 'left',
    width: 80,
  },
  {
    field: 'salesOrderNo',
    title: 'SO订单号',
    align: 'center',
    fixed: 'left',
    minWidth: 150,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'v_printStatus',
    title: '打印状态',
    align: 'center',
    fixed: 'left',
    minWidth: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totQty',
    title: '总件数',
    sortable: true,
    sortType: 'string',
    align: 'center',
    fixed: 'left',
    minWidth: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totBoxNum',
    title: '总箱数',
    sortable: true,
    sortType: 'string',
    align: 'center',
    fixed: 'left',
    minWidth: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totWeight',
    title: '总称重重量',
    sortable: true,
    sortType: 'string',
    headerAlign: 'center',
    align: 'left',
    minWidth: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totVolume',
    title: '总体积',
    headerAlign: 'center',
    sortable: true,
    sortType: 'string',
    align: 'left',
    minWidth: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totVolumeWeight',
    title: '总体积重',
    headerAlign: 'center',
    align: 'center',
    minWidth: 110,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'totPriceWeight',
    title: '总计费重',
    headerAlign: 'center',
    sortable: true,
    sortType: 'string',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
